import { Link, Stack, Typography } from '@mui/material';
import { FallbackProps, ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { DynamicIcon } from 'src/components';
import { useLogout } from 'src/utils/hooks';

const Fallback = ({ resetErrorBoundary }: FallbackProps) => {
  const { logout } = useLogout();
  return (
    <Stack justifyContent="center" alignItems="center" height="100%">
      <DynamicIcon
        sx={{
          fontSize: '16rem',
          width: '16rem',
          height: '16rem',
        }}
        weight={300}
        name="crisis_alert"
      />
      <Typography variant="h3" textAlign="center">
        Something went wrong
      </Typography>
      <Typography variant="body2" textAlign="center">
        You can try to{' '}
        <Link component="button" variant="body2" onClick={resetErrorBoundary}>
          retry last action
        </Link>
        {', '}
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            window.location.reload();
          }}
        >
          reload page
        </Link>
        {' or '}
        <Link component="button" variant="body2" onClick={logout}>
          logout and clear cache
        </Link>
        .
      </Typography>
    </Stack>
  );
};

export const GlobalErrorBoundary = ({ children }: { children: React.ReactNode }) => {
  return <ReactErrorBoundary FallbackComponent={Fallback}>{children}</ReactErrorBoundary>;
};
